"use strict";
import configs from "@/common/config";
import { MessageBox } from "element-ui";
import util from "@/common/utils";
import router from "@/router/index";
import store from "@/store/index";
import { t } from "@/languages";
const isDev = import.meta.env.MODE === "development";
const ajaxUrl = isDev ? configs.devApiUrl : configs.apiUrl;
let messageBox;
const fetchData = (options) =>
  new Promise((resolve, reject) => {
    options.headers = {
      ...options.headers,
      "X-Proxy-token": isDev
        ? configs.defToken
        : sessionStorage.getItem("dfx-token"),
    };
    let fetchConfig = {
      url:
        options.apiUrl.indexOf("https://") > -1
          ? options.apiUrl
          : ajaxUrl + options.apiUrl,
      method: options.method,
      headers: options.headers,
    };
    // 只有 POST、PUT、PATCH、DELETE 等方法才可以有 body
    const methodsWithBody = ["POST", "PUT", "PATCH", "DELETE"];
    if (
      methodsWithBody.includes(options.method?.toUpperCase()) &&
      options.body
    ) {
      fetchConfig.body = options.body;
    }
    // 对于 GET 请求，如果有参数，应该放到 URL 中
    if (options.method?.toUpperCase() === "GET" && options.body) {
      const params = new URLSearchParams(Object.entries(options.body.params));
      fetchConfig.url = `${fetchConfig.url}?${params.toString()}`;
    }
    window.bridge.call(
      "open.api.proxy",
      fetchConfig,
      (data) => {
        const body = data.result.body;
        if (!body) {
          // 断网问题
          window.bridge.call("open.api.proxy", {
            url: `${ajaxUrl}/common/pushApiException`,
            body: {
              apiUrl: options.apiUrl,
              body: options.body,
              message: body.message,
            },
            method: "POST",
            headers: options.headers,
          });
          return resolve({
            code: 500,
            msg: t("网络异常，请稍后再试。"),
          });
        } else if (body.message === "Read timed out") {
          //超时问题 推送日至
          window.bridge.call("open.api.proxy", {
            url: `${ajaxUrl}/common/pushApiException`,
            body: {
              apiUrl: options.apiUrl,
              body: options.body,
              message: body.message,
            },
            method: "POST",
            headers: options.headers,
          });
          return resolve({
            code: 999,
            msg: t("获取数据超时，请稍后再试。"),
          });
        }
        switch (body.code) {
          case 401:
            // 授权过期
            MessageBox.alert(t("登录已过期，请重新登录"), "", {
              type: "warning",
              customClass: "token-expired-alert",
              confirmButtonText: t("重新登录"),
              beforeClose: () => {
                util.goToLogin();
                reject(false);
              },
            });
            break;
          case 3001:
            // 当前无有效的授权店铺
            if (!messageBox) {
              (messageBox = MessageBox.confirm(t(data.msg), t("提示"), {
                confirmButtonText: t("去添加店铺"),
                showClose: false,
                showCancelButton: false,
                type: "warning",
              }).then(() => {
                messageBox = null;
                setTimeout(() => {
                  router.push("/apply/personalManage/shopManage");
                }, 10);
              })).catch(() => {
                messageBox = null;
              });
              reject(body);
            }
            // 路由切换存在messageBox 清除
            // 解决客户不关闭授权过期弹窗，点浏览器返回，下次再报错不弹窗
            router.beforeEach((to, from, next) => {
              if (to.fullPath !== from.fullPath && messageBox) {
                messageBox = null;
              }
              next();
            });
            break;
          case 7001:
            // 付费的版本提示
            store.commit("setPackageTips", {
              key: "package",
              msg: body.msg,
            });
            break;
          case 7002:
            // TEMU授权令牌权限不够
            MessageBox({
              title: "系统检测到您未获取TEMU全部权限，请到Temu后台赋予权限后重新再授权",
              message: '<img src="//oss.dianleida.net/1688-web/images/temu_permission.png" class="temubg" />',
              dangerouslyUseHTMLString: true,
              confirmButtonText: "前往TEMU半托管后台重新获取",
              showClose: false,
              showCancelButton: true,
              customClass: "temu-permission-message-box",
            }).then(() => {
              messageBox = null;
              setTimeout(() => {
                window.open('https://agentseller.temu.com/open/system-manage/client-manage', "_blank");
              }, 10);
            }).catch(() => {
              messageBox = null;
            });
            return reject(body);
          case 7003:
            // token过期
            MessageBox({
              title: "提示",
              message: body.msg,
              type: "warning",
              confirmButtonText: "去处理",
              showClose: false,
              showCancelButton: true,
            }).then(() => {
              messageBox = null;
              setTimeout(() => {
                router.push("/apply/personalManage/shopManage");
              }, 10);
            }).catch(() => {
              messageBox = null;
            });
            return Promise.reject(data);
          default:
            resolve(body);
        }
      },
      (err) => {
        reject(err);
      }
    );
  });

const ajax = {
  get(url, options, config) {
    return fetchData({
      method: "GET",
      headers:
        config && config.headers
          ? config.headers
          : {
            "content-type": "application/json",
          },
      apiUrl: url,
      body: options,
      config,
    });
  },
  post(url, options, config) {
    return fetchData({
      method: "POST",
      headers:
        config && config.headers
          ? config.headers
          : {
            "content-type": "application/json",
          },
      apiUrl: url,
      body: options,
      config,
    });
  },
  isDev: isDev,
  setToken(newToken) {
    token = newToken;
  },
  getToken() {
    return token;
  },
  ajaxUrl,
};

export default ajax;
